import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  highlighted?: boolean;
}
export function Card({
  children,
  className = '',
  highlighted = false,
  ...props
}: CardProps) {
  return <div className={`bg-white rounded-2xl border transition-all duration-300 ${highlighted ? 'border-purple-500 shadow-xl shadow-purple-500/10 ring-2 ring-purple-500' : 'border-gray-200 shadow-sm'} ${className}`} {...props} data-id="element-565">
      {children}
    </div>;
}